module.exports = __webpack_public_path__ + "static/media/amber.6bf26766.png";